import { IApplicationState } from '../../types/redux';

export const selectPageServices = (state: IApplicationState) => state.pageServices;
